import { render, staticRenderFns } from "./ChangeDisplay.vue?vue&type=template&id=a8416cb8&"
import script from "./ChangeDisplay.vue?vue&type=script&lang=js&"
export * from "./ChangeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports